<template>
    <div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="3">

                <input type="checkbox" v-model="isReceivedDo" v-bind:id="invoice.invoiceid">&nbsp;<label v-bind:for="invoice.invoiceid">{{ invoice.markingheadercode }}</label>
                
            </Col>
            <Col span="2">Ctns {{ invoice.totalctns }}</Col>
            <Col span="1">
                <Poptip placement="top" trigger="hover" v-if="invoice.invoiceReceiveDo.length > 0">
                    <Button type="info" size="small">{{invoice.invoiceReceiveDo.length}}</Button>
                    <div class="api" slot="content">
                        <ul>
                            <li v-for="item in invoice.invoiceReceiveDo">
                                - {{ item.notes }}
                            </li>
                        </ul>
                    </div>
                </Poptip>                    
            </Col>                    
            <Col span="16"><Input v-model="notes" placeholder="Notes.." size="small" ></Input></Col>
        </Row>                
    </div>
</template>

<script>

export default {
    props: {
        invoice : Object,
        checkAll : Boolean
    },
    data: () => ({
        invoiceChanged : {},
        notes : '',
        isReceivedDo : false,
        arr : [],
        arrIndex : {}
    }),  
    methods: {
        setInvoiceChanged: function (){
            this.$emit('setInvoiceChanged', this.invoiceChanged)
        }
    },
    watch: {
        checkAll: function (newObj) {
            this.isReceivedDo = newObj 
            this.setInvoiceChanged();
        },        
        isReceivedDo: function (newObj) {
            this.invoiceChanged.isReceivedDo = newObj;
            this.setInvoiceChanged();
        },
        notes: function (newObj) {
            this.invoiceChanged.notes = newObj;
            this.setInvoiceChanged();
        }
    },    
    created() {
        this.invoiceChanged.invoiceid = this.invoice.invoiceid
        this.invoiceChanged.isReceivedDo = this.isReceivedDo
        this.invoiceChanged.notes = this.notes
    }      
}


</script>
<style>
</style>


// WEBPACK FOOTER //
// cInvoiceReceiveRow.vue?5f009b1e